import { Component, OnInit, EventEmitter, Input, Output  } from '@angular/core';

import { LevelsComponent } from '../levels/levels.component';

@Component({
  selector: 'app-exercise-starter',
  templateUrl: './exercise-starter.component.html',
  styleUrls: ['./exercise-starter.component.css']
})
export class ExerciseStarterComponent implements OnInit {
  @Input() inNavLinks; 
  @Input() inState = 'init'; 
  @Input() inPoints: number = 0; 
  @Output() onSetLevel = new EventEmitter<number>();
  @Output() onSetState = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    this.inState = 'init'
  }

  onStart() {
    this.inState = 'started';
    this.onSetState.emit('true')
  }  

  setPoints(val: number) {
    this.inState = 'tryAgain';
    this.inPoints = val;    
  }
      
  setLevel(newLevel: number)
  {
    if (newLevel)
    {
      this.onSetLevel.emit(newLevel);
    }
  }
  

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/exercise-starter/exercise-starter.component.ts